export function framesToSeconds(frame: number, fps: number): number {
  return frame / fps;
}

export function secondsToFrames(seconds: number, fps: number): number {
  return Math.round(seconds * fps);
}

export function quantizeToFrame(seconds: number, fps: number): number {
  return secondsToFrames(seconds, fps) / fps;
}

export function formatTimecode(seconds: number, fps = 30, includeFrames = true): string {
  const safe = Math.max(0, Number.isFinite(seconds) ? seconds : 0);
  const totalFrames = Math.floor(safe * fps + 1e-7);
  const frames = totalFrames % Math.round(fps);
  const totalSeconds = Math.floor(totalFrames / fps);
  const s = totalSeconds % 60;
  const m = Math.floor(totalSeconds / 60) % 60;
  const h = Math.floor(totalSeconds / 3600);
  const base = [h, m, s].map((value) => String(value).padStart(2, '0')).join(':');
  return includeFrames ? `${base}:${String(frames).padStart(2, '0')}` : base;
}

export function parseTimecode(value: string, fps = 30): number | null {
  const parts = value.trim().split(':').map(Number);
  if (parts.some(Number.isNaN) || parts.length < 2 || parts.length > 4) return null;
  const [h, m, s, f] = parts.length === 4
    ? parts
    : parts.length === 3
      ? [0, parts[0], parts[1], parts[2]]
      : [0, parts[0], parts[1], 0];
  if ([h, m, s, f].some((part) => part < 0) || m >= 60 || s >= 60 || f >= fps) return null;
  return h * 3600 + m * 60 + s + f / fps;
}
